import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ResolverModule } from './resolver/resolver.module';
import { CoreBuildingBlockControlBaseComponent } from './shared/building-block-control-base.component';
import { ControlsModule } from './controls/controls.module';
import { BuildingBlockSharedModule } from './shared/shared.module';

// tslint:disable-next-line: completed-docs
@NgModule({
  declarations: [CoreBuildingBlockControlBaseComponent],
  exports: [BuildingBlockSharedModule],
  imports: [CommonModule, ResolverModule, BuildingBlockSharedModule, ControlsModule]
})
export class CoreBuildingBlockModule {}
